<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
    error: NuxtError
}>()

const statusCode = computed(() => Number(props.error?.statusCode || props.error?.status || 500))
const isClientError = computed(() => statusCode.value >= 400 && statusCode.value < 500)

/**
 * Nuxt 4.2+ injects <nuxt-error-overlay> after error.vue HTML in dev.
 * Hide it for 4xx immediately via CSS (SSR). The client plugin also removes
 * the node so shadow-DOM / re-injected overlays cannot cover the branded page.
 */
useHead(() => {
    const head: {
        title: string
        style?: Array<{ key: string, innerHTML: string }>
    } = {
        title: statusCode.value === 404 ? 'Page Not Found | Peekage' : 'Error | Peekage',
    }

    if (import.meta.dev && isClientError.value) {
        head.style = [
            {
                key: 'peekage-hide-4xx-error-overlay',
                innerHTML: 'nuxt-error-overlay { display: none !important; }',
            },
        ]
    }

    return head
})

onMounted(() => {
    if (import.meta.dev && isClientError.value) {
        document.querySelectorAll('nuxt-error-overlay').forEach((node) => {
            node.remove()
        })
    }
})
</script>

<template>
    <UApp>
        <NuxtLayout name="default">
            <ErrorPageContent
                :status-code="statusCode"
                clear-nuxt-error
            />
        </NuxtLayout>
    </UApp>
</template>
